export default {
  'basicData': {
    'lastName': '홍',
    'firstName': '길동',
    'lastNameFurigana': '',
    'firstNameFurigana': '',
    'birthYear': '2002',
    'birthMonth': '5',
    'birthDay': '8',
    'sex': '1',
    'postNumber': '12345',
    'address1': '서울시 종로구 xx동',
    'address2': 'xx아파트 xxx동 xx호',
    'addressFurigana': '',
    'tel1': '010',
    'tel2': '1234',
    'tel3': '5678',
    'mobile': '',
    'fax': '',
    'email': 'email@yagish.jp',
    'idPhotoSrc': '/kr/resume/static/img/id-photo-sample.jpg',
    'useContact': [''],
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'formatId': 'rirekisho',
    'saveName': 'rirekisho',
    'educationalHistories': [
      {
        'year': 2013,
        'month': 2,
        'description': 'XX중학교 졸업',
        'uuid': '4005e384-8ce0-405b-b0f1-dea47be1a4cb'
      },
      {
        'year': 2013,
        'month': 3,
        'description': 'XX고등학교 입학',
        'uuid': 'e193e07f-1cf2-4930-bd52-1065f88c2c4e'
      },
      {
        'year': 2016,
        'month': 2,
        'description': 'XX고등학교 졸업',
        'uuid': '108c84e3-ae50-40e7-90f5-0becc48785b4'
      },
      {
        'year': 2016,
        'month': 3,
        'description': 'XX대학교 입학',
        'uuid': 'ef19cdf2-34f2-4076-a4bd-3381841cf987'
      },
      {
        'year': 2022,
        'month': 2,
        'description': 'XX대학교 졸업',
        'uuid': '99a44d4a-73c6-4440-8247-7bf14ec960bd'
      }
    ],
    'jobHistories': [
      {
        'year': '2023',
        'month': '5',
        'description': '주식회사 XXX입사',
        'uuid': '636850ef-d6c0-4c22-91b7-bc2508c76fe4'
      },
      {
        'year': '',
        'month': '',
        'description': '재직중',
        'uuid': '286a59ea-e324-40e5-a09d-eea79751ba54'
      }
    ],
    'licenseHistories': [
      {
        'year': '2013',
        'month': '4',
        'description': '컴퓨터활용자격증',
        'uuid': 'a2e09439-2c36-4981-a643-2b0f7adab257'
      },
      {
        'year': '2014',
        'month': '6',
        'description': 'TOEIC 취득 700점',
        'uuid': 'd6d648f8-30dd-4c09-9367-036416723c1c'
      }
    ],
    'commuteHours': '0',
    'commuteMinutes': '40',
    'commuteDescription': '자차소유',
    'spouseNumber': '0',
    'hasSpouse': false,
    'underDutyToSupport': false,
    'reason': '이전 직장에서는 X년간 XX업무에 종사해 왔습니다.귀사의 XX에 대해서는 예전부터 흥미를 느꼈고 XX한 부분에 매우 매력을 느낍니다.지금까지의 경험을 살리면서 XX등의 스킬을 더 익혀 귀사의 XX업무에 공헌하고 싶다고 생각하여 지원하게 되었습니다.',
    'request': '협의후결정',
    'updateDate': ''
  }
}
